import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=e2309330&scoped=true"
import script from "./Page404.vue?vue&type=script&lang=js"
export * from "./Page404.vue?vue&type=script&lang=js"
import style0 from "./Page404.vue?vue&type=style&index=0&id=e2309330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2309330",
  null
  
)

export default component.exports